import { render, staticRenderFns } from "./MessageIndex.vue?vue&type=template&id=46b954eb&scoped=true&"
import script from "./MessageIndex.vue?vue&type=script&lang=js&"
export * from "./MessageIndex.vue?vue&type=script&lang=js&"
import style0 from "./MessageIndex.vue?vue&type=style&index=0&id=46b954eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b954eb",
  null
  
)

export default component.exports